// Fastclick
// import attachFastClick from 'fastclick';

// Import polyfills
import 'whatwg-fetch';
import 'es6-promise/auto';
import './polyfills/array-from';
import './polyfills/element-closest'; // Imports element.matches aswell
import './polyfills/object-assign';
import './polyfills/nodelist-foreach';
import './polyfills/node-prepend';
import './polyfills/classlist-toggle';
import './polyfills/placeholder-shown';
import './polyfills/transition-end';
import './polyfills/custom-events';
import 'picturefill';
import svg4everybody from 'svg4everybody';

// Adds Jcrop to jQuery (jQuery loaded via cdn)
import './libs/jcrop';

// Import helpers/libraries
// import detect from './helpers/detect';
import devTools from './dev/dev-tools';
import EQ from 'css-element-queries';
import smoothscroll from './helpers/smoothscroll';
import './libs/what-input';

// Init Element Queries
EQ.ElementQueries.listen();

// add fastclick
// attachFastClick(document.body);

// Modules
import coverModes from './modules/cover-modes.js';
import liveTickers from './modules/live-tickers';
import eventLists from './modules/m08-toplist-online-registration';
import desktopNavigation from './modules/m01-1-desktop-navigation.js';
import mobileNavigation from './modules/m01-2-mobile-navigation.js';
import sidebar from './modules/m16-sidebar.js';
import tabs from './modules/m20-tabs';
import forms from './modules/m21-form';
import map from './modules/m22-map';
import personListView from './modules/m34-person-listview';
import calendar from './modules/m07-calendar.js';
import personInfoOverlay from './modules/m36-person-info-overlay';
import imageUpload from './modules/m21-9-image-upload';
import video from './modules/m25-3-video';
import imageGalleries from './modules/m40-image-galleries';
import lightbox from './modules/lightbox';
import mergePersonPanel from './modules/merge-person-panel';
import categorySelector from './modules/m12-category-selector';
import shoppingCartOverlay from './modules/m11-shopping-cart-overlay';
import shop from './modules/m11-shop';
import personalEventlistOverlay from './modules/m33-personal-eventlist-overlay';
import simpleImageUploads from './modules/simple-image-uploads';

// Components
import buttons from './components/buttons';
import accordion from './components/accordion';
import listOrderOptions from './components/list-order-options';

// Singletons
import './singletons/viewport-watcher';

desktopNavigation.init();

mobileNavigation({
    moduleId: 'mobile-navigation',
    navClass: 'mobilenav',
    triggerId: 'mobile-trigger',
    rtl: true
});

smoothscroll({
    offset: (top) => top > 180 ? -90 : -165
});

sidebar.init();
listOrderOptions.init();
map.init(); // TODO
mergePersonPanel.init();
categorySelector.init();
shoppingCartOverlay.init();
personalEventlistOverlay.init();
shop.init();
accordion.init({ accordionMode: false });
personListView.init();
personInfoOverlay.init();
buttons.init();
video.init();
imageUpload.init();
liveTickers.init();
eventLists.init();

// Has to be initiated very late
forms.init();
tabs.init({ accordionMode: false });
imageGalleries.init();
simpleImageUploads.init();
lightbox.init();

// Supply BE Devs with a function to call after DOM manipulations (adding/removing whole blocks)
window.initModules = () => {
    video.init();
    liveTickers.init();
    eventLists.init();
    imageUpload.initFactories();
    personInfoOverlay.init();
    forms.init();
    personListView.init();
    accordion.init({ accordionMode: false });
    mergePersonPanel.init();

    tabs.destroy();
    tabs.init({ accordionMode: false });
    imageGalleries.init();
    simpleImageUploads.init();
    lightbox.init();

    // Destroy and reinitiate covermodes
    coverModes.destroy();
    coverModes.init();

    // In case Images are loaded very slow, execute the refresh in a timeout. (in very slow environments, would still fail)
    setTimeout(() => {
        coverModes.refresh();
    }, 300);
};

window.addEventListener('load', () => {
    calendar.init();
    coverModes.init();
});

// for IE/EDGE svg sprite support
svg4everybody();

